/**
 * Image upload limits shared by the post composer and the comment composers.
 *
 * These used to live in Posts/PostFormModal, so OrderCommentsSection — which is also
 * rendered by Orders, Calendar and Menu — had to import from the Posts tree, dragging
 * fetchAllResidentGroups and the Group type into bundles that have nothing to do with
 * posts. Both constants are plain data, so they belong here.
 *
 * MAX_FILE_SIZE mirrors the cap the presigned-upload path expects; raising it here
 * without raising it server-side just moves the rejection later.
 */
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
